import { Injectable } from '@angular/core';
import { MedicalToolSetModel } from '../entity/medicalToolSet.model';
import { MedicalToolSetSummaryModel } from '../entity/medicalToolSetSummary.model';
import { MedicalToolSetRepository } from '../../impl/service/repository/medicalToolSet.repository';
import { MedicalToolSetSummaryDataServiceAdapter } from '../../impl/service/repository/medicalToolSetSummary.dataserviceadapter';
import { AbstractFindAllService } from 'src/app/modules/core/service/v2/service/findAll/abstractFindAll.service';

@Injectable()
export class MedicalToolSetSummaryFindAllService extends AbstractFindAllService<MedicalToolSetModel, MedicalToolSetSummaryModel> {
    constructor(repository: MedicalToolSetRepository, serviceAdapter: MedicalToolSetSummaryDataServiceAdapter) {
        super(repository, serviceAdapter);
    }

    ngOnDestroy(): void {
        super.onDestroy();
    }
}

